import { ErrorKinds } from "./errorKinds.js";

const TEMPORARY_INFRA_STATUSES = new Set([500, 502, 503, 504]);
const CONNECTIVITY_CODES = new Set(["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"]);

/**
 * Classifies an error into a generic UI kind (connectivity, temporary infra, unexpected, forbidden).
 * Accepts axios errors, plain Errors, and odd shapes from ErrorBoundary / notifications.
 *
 * @param {unknown} error
 * @returns {typeof ErrorKinds[keyof typeof ErrorKinds]}
 */
export function classifyError(error) {
  const status = error?.response?.status;
  if (status === 403) {
    return ErrorKinds.forbidden;
  }
  if (TEMPORARY_INFRA_STATUSES.has(status)) {
    return ErrorKinds.temporaryInfra;
  }

  const code = error?.code;
  const message = typeof error?.message === "string" ? error.message.toLowerCase() : "";
  if (
    status === 0 ||
    CONNECTIVITY_CODES.has(code) ||
    message.includes("network error") ||
    message.includes("timeout")
  ) {
    return ErrorKinds.connectivity;
  }

  return ErrorKinds.unexpectedApp;
}
